import React from 'react';
import { CopyableText } from '../ui/CopyableText';

/**
 * Where a shipment is going: who receives it, and where.
 *
 * Both strings are cut to fit and copyable, like the reference and the tracking
 * number of the neighbouring columns. Printed whole, a long recipient or a long
 * street widened the column and pushed the table into a sideways scroll.
 *
 * The commune stays visible even though the address already ends with it: it is
 * what the table is scanned by, while the address is what gets copied. The
 * report builds that string as
 * `CONCAT(street, ' ', street_number, ' ', commune, ' ', region)` and Postgres'
 * `CONCAT` skips a NULL but not its separator, so an address without a number
 * arrives with a double space in the middle.
 *
 * @param {object} props
 * @param {{customer?: string, commune?: string, address?: string}} props.row
 */
export const DestinationCell = ({ row }) => {
  const address = row.address ? row.address.replace(/\s+/g, ' ').trim() : '';

  return (
    <div className="flex flex-col min-w-0">
      <CopyableText
        value={row.customer}
        maxWidth="140px"
        className="font-medium text-ninja-dark dark:text-white"
        emptyClassName="font-medium text-text-muted"
      />
      <div className="flex items-center gap-1 min-w-0 mt-0.5 text-xs text-text-muted">
        <span className="shrink-0">{row.commune || '-'}</span>
        {address && (
          <>
            <span aria-hidden="true">·</span>
            <CopyableText value={address} maxWidth="150px" className="text-xs text-text-muted" />
          </>
        )}
      </div>
    </div>
  );
};
